module.exports = __webpack_public_path__ + "static/media/bmce.a17f581a.png";